import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Problem = () => {
    const { t } = useLanguage();
    const styles = {
        section: {
            padding: '100px 32px',
            backgroundColor: '#F9F9F9',
        },
        container: {
            maxWidth: '1000px',
            margin: '0 auto',
            textAlign: 'center',
        },
        h2: {
            fontSize: '48px',
            fontWeight: '800',
            marginBottom: '40px',
            color: '#2B2B2B',
        },
        highlight: {
            color: '#3457D5',
        },
        card: {
            backgroundColor: '#FFFFFF',
            padding: '48px',
            borderRadius: '24px',
            border: '1px solid #E5E5E5',
            boxShadow: '0 10px 40px rgba(15,15,35,0.08)',
        },
        text: {
            fontSize: '24px',
            color: '#414141',
            lineHeight: '1.7',
            marginBottom: '20px',
        },
        accentText: {
            color: '#F28C46',
            fontWeight: '700',
        },
        boldText: {
            fontSize: '28px',
            fontWeight: '700',
            color: '#2B2B2B',
        },
    };

    const isMobile = window.innerWidth < 768;
    if (isMobile) {
        styles.section.padding = '60px 20px';
        styles.h2.fontSize = '32px';
        styles.text.fontSize = '18px';
        styles.boldText.fontSize = '22px';
        styles.card.padding = '32px 24px';
    }

    return (
        <section style={styles.section}>
            <div style={styles.container}>
                <h2 style={styles.h2}>
                    {t('problem.title')}<span style={styles.highlight}>{t('problem.titleHighlight')}</span>
                </h2>
                <div style={styles.card}>
                    <p style={styles.text}>
                        {t('problem.text')}<span style={styles.accentText}>{t('problem.textHighlight')}</span>
                        {t('problem.textEnd')}
                    </p>
                    <p style={styles.boldText}>
                        {t('problem.boldText')}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Problem;
